<template>
    <div>

        <vue-headful title="Employees :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item active"><i class="fa fa-group"></i> Employees</li>
                <li class="ml-3">
                    <router-link :to="`/employees/create`" class="btn btn-sm btn-success"><i class="fa fa-plus-circle"></i> Create</router-link>
                </li>
                <li class="ml-2">
                    <b-dropdown size="sm" variant="light" :disabled="generating">
                        <template #button-content>
                            <template v-if="generating">
                                <i class="fa fa-spin fa-spinner"></i> Generating
                            </template>
                            <template v-else>
                                <i class="fa fa-files-o"></i> Actions
                            </template>
                        </template>
                        <b-dropdown-item v-on:click="sendToImport()"><i class="fa fa-file-excel-o"></i> Import</b-dropdown-item>
                        <b-dropdown-item v-on:click="generateQRCodes()"><i class="fa fa-file-zip-o"></i> Generate QR Codes (Filters Apply)</b-dropdown-item>
                        <b-dropdown-item v-on:click="generateQRCodes(true)"><i class="fa fa-file-pdf-o"></i> Printer Friendly QR Codes (Filters Apply)</b-dropdown-item>
                    </b-dropdown>
                </li>
            </ol>
        </h4>

        <saved-filter-title :filterKey="'employeeFilters'" />

        <div class="card">
            <div class="card-body">
                <employee-list ref="empIndexList" :allowFilterSaving="true" :filterId="(filter_id ? parseInt(filter_id) : null)" />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                filter_id: this.$route.query.filter_id,
                generating: false,
            }
        },

        methods: {
            sendToImport(){
                //Send it
                this.$router.push('/employees/import');
            },

            generateQRCodes(pdf_version = false){
                //Loading
                this.generating = true;

                //Get the filters from the employee list
                var filters = JSON.stringify(this.$refs.empIndexList.getFilters());

                //setup
                var payload = this.$refs.empIndexList.$refs.employeesTable.getRequestParams();

                //Setup
                payload.filters = filters;

                //Check for PDF version
                if(pdf_version)
                {
                    //Send to it
                    window.location = '/employees/qr-codes?' + this.$root.encodeGetParams(payload);

                    //Stop here
                    this.generating = false;

                    //Done
                    return;
                }

                //Get the data
                this.$http
                    .post('employees/qr-codes', payload)
                    .then(response => {
                        //Set all the data
                        window.location = '/files/download/export/' + response.data.zip_file_name;
                    })
                    .catch(response => {
                        //Do something?
                    })
                    .then(() => {
                        //Reset
                        this.generating = false;
                    });
            },
        },
    }
</script>
